import React, { Component } from 'react';
import ProductCard from "../../customComponents/productCard/productCard";
import {
    Button,
    CircularProgress,
    Divider,
    Grid
} from "@mui/material";
import { Link, useNavigate } from 'react-router-dom';
import { Product } from "../../../classes/types/product/product";
import { ProductHandler } from "../../../classes/methods/productMethods/productMethods";
import { Pagination } from "@mui/lab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import FilterPage from "../../customComponents/filterPage/filterPage";

// Props aggiornate con navigate
interface props {
    page?: string;
    products?: Array<Product>;
    navigate: ReturnType<typeof useNavigate>;
}

interface state {
    loading: boolean;
    products: Array<Product>;
    pageProducts: Array<Product>;
    currentPage: number;
    pageNumber: number;
    numberProductsInPage: number;
    productsToView: Array<Product>;
    isLogged: boolean;
}

class EndingProducts extends Component<props, state> {
    constructor(props: props) {
        super(props);
        this.state = {
            products: [],
            pageProducts: [],
            numberProductsInPage: 20,
            currentPage: this.props.page !== undefined ? Number(this.props.page) : 1,
            pageNumber: 1,
            productsToView: [],
            loading: true,
            isLogged: false,
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    componentDidUpdate(prevProps: Readonly<props>) {
        if (this.props.page !== prevProps.page) {
            this.refreshData();
        }
    }

    refreshData = () => {
        this.setState({ loading: true });

        if (this.props.products && this.props.products.length > 0) {
            const newProductsArray = this.props.products.filter(p => p.stock1 > 0 && p.stock1 <= 2);
            this.updatePagination(newProductsArray);
        } else {
            ProductHandler.GetAllLowStockProducts()
                .then((newProducts) => this.updatePagination(newProducts))
                .catch(() => { });
        }
    }

    updatePagination = (productsArray: Array<Product>) => {
        const startingPoint = this.props.page ? (Number(this.props.page) - 1) * this.state.numberProductsInPage : 0;
        const newProductsPage = productsArray.slice(startingPoint, startingPoint + this.state.numberProductsInPage);
        const pageNumber = Math.ceil(productsArray.length / this.state.numberProductsInPage);

        this.setState({
            loading: false,
            currentPage: this.props.page ? Number(this.props.page) : 1,
            products: productsArray,
            pageProducts: newProductsPage,
            pageNumber: pageNumber,
            productsToView: productsArray,
            isLogged: this.isLogged(productsArray)
        });
    }

    onPageChange = (e: any, page: number) => {
        this.props.navigate(`/shop/ending/page/${page}`);

        const startingPoint = (page - 1) * this.state.numberProductsInPage;
        const newProductsPage = this.state.productsToView.slice(startingPoint, startingPoint + this.state.numberProductsInPage);

        this.setState({ pageProducts: newProductsPage, currentPage: page });
    }

    isLogged = (products: Array<Product>) => {
        return products.some(p => !p.configurable && p.price !== undefined);
    }

    onProductsFiltered = (newProductsToView: Array<Product>) => {
        const pageNumber = Math.ceil(newProductsToView.length / this.state.numberProductsInPage);
        const newProductsPage = newProductsToView.slice(0, this.state.numberProductsInPage);

        this.setState({
            productsToView: newProductsToView,
            pageProducts: newProductsPage,
            pageNumber: pageNumber,
            currentPage: 1,
        });
        this.props.navigate(`/shop/ending/page/1`);
    }

    render() {
        return (
            <div style={{ wordBreak: "break-word" }}>
                <Grid container>
                    <Grid xs={2} item>
                        <FilterPage
                            isLogged={this.state.isLogged}
                            products={this.state.products}
                            loading={this.state.loading}
                            availability={false}
                            onProductsFiltered={this.onProductsFiltered}
                        />
                    </Grid>
                    <Grid xs={10} item>
                        {this.state.loading ? <CircularProgress /> :
                            this.state.products.length < 1 ? (
                                <div style={{ marginTop: '10%' }}>
                                    <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                                    <h1>Nessun Prodotto Trovato</h1>
                                    <Link to={'/'}><Button variant="contained" color="primary">Ritorna alla Pagina Iniziale</Button></Link>
                                </div>
                            ) : this.state.pageProducts.length < 1 ? (
                                <div style={{ marginTop: '10%' }}>
                                    <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                                    <h1>Non Esistono Prodotti Con Queste Specifiche</h1>
                                </div>
                            ) : (
                                <div style={{ paddingLeft: '2%', paddingRight: '2%' }} className="configurable-systems">
                                    <div style={{ display: "flex", justifyContent: "center", padding: "0.5% 0% 1% 0%" }}>
                                        <Pagination color="primary" count={this.state.pageNumber} page={this.state.currentPage} onChange={this.onPageChange} />
                                    </div>
                                    <Divider variant="middle" style={{ marginBottom: '1%' }} />
                                    {this.state.pageProducts.map((product, index) => (
                                        <div key={index}>
                                            <ProductCard
                                                isLogged={this.state.isLogged}
                                                linkName={`/shop/ending/page/${this.state.currentPage}/prodotto/${product.id}`}
                                                loading={this.state.loading}
                                                product={product}
                                            />
                                            <Divider variant="middle" style={{ marginBottom: '1%' }} />
                                        </div>
                                    ))}
                                    <div style={{ display: "flex", justifyContent: "center", padding: "0.5% 0% 1% 0%" }}>
                                        <Pagination color="primary" count={this.state.pageNumber} page={this.state.currentPage} onChange={this.onPageChange} />
                                    </div>
                                </div>
                            )
                        }
                    </Grid>
                </Grid>
            </div>
        );
    }
}

// --- Wrapper per React Router v6
export default function EndingProductsWrapper(props: any) {
    const navigate = useNavigate();
    return <EndingProducts {...props} navigate={navigate} />;
}
